// @ts-nocheck
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import '@sistemiv/s-components/dist/TC.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import LoadingLogo from './assets/loading_logo.png'
import { msalInstance } from './services/AuthConfig'
import { EventType } from '@azure/msal-browser'
import './services/i18n'

const AUTH_PROVIDER = process.env.REACT_APP_AUTH_PROVIDER

if (AUTH_PROVIDER === 'msal') {
  msalInstance.initialize().then(() => {
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
    }

    msalInstance.addEventCallback((event) => {
      if (
        event.eventType === EventType.SSO_SILENT_SUCCESS ||
        event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
      ) {
        const account = event.payload?.account
        msalInstance.setActiveAccount(account)
      }

      if (event.eventType === EventType.LOGOUT_SUCCESS) {
        document.cookie = `refreshOrganization=true; path=/; max-age=3; domain=.sistemiv.com`
      }
    })

    msalInstance.enableAccountStorageEvents()
  })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.Suspense
    fallback={
      <div className='w-screen h-screen flex items-center justify-center'>
        <img src={LoadingLogo} />
      </div>
    }
  >
    <App pca={AUTH_PROVIDER === 'msal' ? msalInstance : null} />
  </React.Suspense>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
